import TableRenderClass from '@C/tableRender/tableRenderClass';
import { invoice } from '@/api/ajax';
import Vue from 'vue';
import { moneyFixed } from '@/tools/money';

const defineReactive = Vue.util.defineReactive;
const INVOICE_CATEGORY = new Map([
  [1, '增值税普通发票'],
  [2, '增值税专用发票']
]);
const fields = {
  index: {
    label: '序号',
    type: 'index',
    width: '50px'
  },

  fullName: {
    label: '项目参与人', //"用户名",
    prop: 'fullName'
  },
  expand: {
    label: '',
    width: '150px',
    type: 'expand',
    render: (h, ctx, row) => {
      const { invoiceDetailList } = row;
      return h(
        'table',
        {
          style: {
            // border:'none',
            width: '100%',
            fontSize: '12px',
            textIndent: '2em',
            // boxShadow:'2px 3px 5px #c0c4cc',
            boxShadow: '1px 2px 5px #c0c4cc',
            cellSpacing: '0',
            cellPadding: '0',
            borderCollapse: 'collapse',
            borderRadius: '5px',
            overflow: 'hidden'
            // border:'1px solid #c1c1c1',
            // background:'#a3d0fd'
          }
        },
        [
          h('thead', [
            h('tr', [
              h(
                'th',
                {
                  style: {
                    width: '50px',
                    borderRight: 'none'
                  }
                },
                ''
              ),
              h(
                'th',
                {
                  style: {
                    borderRight: 'none'
                  }
                },
                '项目名称'
              ),
              h(
                'th',
                {
                  style: {
                    borderRight: 'none'
                  }
                },
                '任务月度'
              ),
              h(
                'th',
                {
                  style: {
                    borderRight: 'none'
                  }
                },
                '开票金额'
              )
            ])
          ]),
          h('tbody', [
            invoiceDetailList.length &&
              invoiceDetailList.map((e, i) =>
                h('tr', [
                  h(
                    'td',
                    {
                      style: {
                        borderRight: 'none'
                      }
                    },
                    i + 1
                  ),
                  h(
                    'td',
                    {
                      style: {
                        borderRight: 'none'
                      }
                    },
                    e.projectName
                  ),
                  h(
                    'td',
                    {
                      style: {
                        borderRight: 'none'
                      }
                    },
                    e.taskDt
                  ),
                  h(
                    'td',
                    {
                      style: {
                        borderRight: 'none'
                      }
                    },
                    moneyFixed(e.projectPrice)
                  )
                ])
              )
          ])
        ]
      );
    }
  },
  userPhone: {
    label: '手机号', //"用户手机号",
    prop: 'userPhone'
  },
  projectPriceTotal: {
    label: '开票金额', //"总金额  long类型 ",
    prop: 'projectPriceTotal',
    formatter: (r, c, v) => moneyFixed(+v)
  },
  invoiceCategory: {
    label: '发票类别', //"一级类目 int类型   1 增值税普通发票 2增值税专用发票 ",
    prop: 'invoiceCategory',
    // formatter: (r, c, v) => INVOICE_CATEGORY.get(+v),
    // defineReactive(r,'$value','');
    render: (h, ctx, r, c) => {
      // defineReactive(r, '$invoiceCategory', 1);
      const options = [];
      INVOICE_CATEGORY.size &&
        INVOICE_CATEGORY.forEach((v, k) => {
          options.push({ label: v, key: k });
        });

      return h('div', [
        h(
          'el-select',
          {
            props: {
              size: 'mini',
              // value: INVOICE_CATEGORY.get[r.$invoiceCategory]
              value: r.invoiceCategory
            },
            on: {
              input: v => {
                r.invoiceCategory = +v;
                defineReactive(r, '$isChange', true);

                let invoiceCategory = r.defaultInvoicingTypeList.find(
                  i => i.id === v
                );

                invoiceCategory && (r._invoiceItems = invoiceCategory.children);
                invoiceCategory &&
                  ((r.invoiceItemId = invoiceCategory.children[0].id),
                  (r.itemName = invoiceCategory.children[0].itemName));
              }
            }
          },
          [
            options.map(i =>
              h('el-option', {
                props: {
                  label: i.label,
                  value: i.key
                }
              })
            )
          ]
        )
      ]);
    }
  },
  itemName: {
    label: '发票类目', //"二级类目名字",
    prop: 'itemName',
    render: (h, ctx, r) => {
      return h('div', [
        h(
          'el-select',
          {
            props: {
              size: 'mini',
              // value: INVOICE_CATEGORY.get[r.$invoiceCategory]
              value: r.invoiceItemId,
              disabled: !r._invoiceItems.length,
              placeholder: '当前发票类别下 没有发票类目'
            },
            on: {
              input: v => {
                r.invoiceItemId = v;
                defineReactive(r, '$isChange', true);
                let item = r._invoiceItems.find(i => i.id == v);
                item && (r.itemName = item.itemName);
              }
            }
          },
          [
            r._invoiceItems &&
              r._invoiceItems.map(i =>
                h('el-option', {
                  props: {
                    label: i.itemName,
                    value: i.id
                  }
                })
              )
          ]
        )
      ]);
    }
  }
};

//初始化
export let example = new TableRenderClass({ fields });

export const openContent = [
  {
    name: '申请委托|开票内容',
    childMenu: [
      example.createPart({
        name: '申请委托|开票内容',
        search: [],
        list: invoice.contentOfMakeOutAnInvoice,
        requestNow: true,
        defaultQuery: {},
        fields: [
          'expand',
          'index',
          'fullName',
          'userPhone',
          'projectPriceTotal',
          'invoiceCategory',
          'itemName',
          'invoiceItemId'
        ],
        moreBtnArr: []
      })
    ]
  }
];
